// import {
//   Id
// Request,
// RequestAgencyStatus,
// RequestTicket,
// RequestTicketType,
// ResponseDataPaginate
// } from 'src/types'

export enum AgreementActionTypes {
  GET_AGREEMENT = '@agreement/GET_AGREEMENT',
  GET_AGREEMENT_FAILURE = '@agreement/GET_AGREEMENT_FAILURE',
  GET_AGREEMENT_SUCCESS = '@agreement/GET_AGREEMENT_SUCCESS',
  SEND_AGREEMENT = '@agreement/SEND_AGREEMENT',
  SEND_AGREEMENT_FAILURE = '@agreement/SEND_AGREEMENT_FAILURE',
  SEND_AGREEMENT_SUCCESS = '@agreement/SEND_AGREEMENT_SUCCESS'
}

export type ResponseDataRequests = {
  agreements: ResponseDataRequestsItem[]
}

export interface ResponseDataRequestsItem {
  agreement_id: number
  organization_id: number
  service_hub_id: number
  agreement_type: string
  integration_type: string
  name: string
  code: number
}

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}

export type AgreementState = ResponseDataRequestTotals & {
  readonly error: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly sendAgreementError: string
  readonly sendAgreementLoading: boolean
  readonly total_results: number
}
